<template>
  <div class="plans-faq">
    <h3 class="plans-faq__title">Preguntas frecuentes</h3>
    <div class="plans-faq__list">
      <div
        v-for="(item, index) in faqs"
        :key="index"
        class="plans-faq__item"
        :class="{ 'is-open': openIndex === index }"
      >
        <button type="button" class="plans-faq__header" @click="toggle(index)">
          <span class="plans-faq__question">{{ item.q }}</span>
          <i
            class="el-icon-arrow-down plans-faq__icon"
            :class="{ 'is-rotated': openIndex === index }"
          ></i>
        </button>
        <transition name="faq-slide">
          <div v-if="openIndex === index" class="plans-faq__body">
            <p class="plans-faq__answer">{{ item.a }}</p>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PlansFAQ",
  data() {
    return {
      openIndex: null,
      faqs: [
        {
          q: "\u00bfQu\u00e9 cuenta como documento?",
          a:
            "Facturas, notas de cr\u00e9dito, notas de d\u00e9bito, liquidaciones de compra y retenciones electr\u00f3nicas. Las cotizaciones son siempre ilimitadas en todos los planes."
        },
        {
          q: "\u00bfPuedo cambiar de plan?",
          a:
            "S\u00ed, en cualquier momento. Si mejoras tu plan se aplica de inmediato. Si bajas, el cambio se aplica al final de tu per\u00edodo actual."
        },
        {
          q: "\u00bfQu\u00e9 pasa si llego al l\u00edmite de documentos?",
          a:
            "Te avisamos cuando est\u00e9s al 80%. Al llegar al l\u00edmite puedes mejorar tu plan al instante o esperar al siguiente mes."
        },
        {
          q: "\u00bfC\u00f3mo funciona la firma electr\u00f3nica?",
          a:
            "Es un servicio adicional que activas desde tu cuenta. Compras firmas individuales a $24 + IVA y las usas cuando necesites. Con validez legal en Ecuador bajo la Ley 67."
        }
      ]
    };
  },
  methods: {
    toggle(index) {
      this.openIndex = this.openIndex === index ? null : index;
    }
  }
};
</script>

<style lang="scss" scoped>
.plans-faq {
  &__title {
    font-size: 22px;
    font-weight: 700;
    color: #2d2b55;
    margin: 0 0 16px;
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  &__item {
    border-bottom: 1px solid #e8ecf1;

    &:first-child {
      border-top: 1px solid #e8ecf1;
    }
  }

  &__header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 18px 4px;
    background: none;
    border: none;
    cursor: pointer;
    text-align: left;
    transition: background 0.12s;

    &:hover {
      background: #f9fafb;
    }
  }

  &__question {
    font-size: 14px;
    font-weight: 600;
    color: #2d2b55;
    flex: 1;
  }

  &__icon {
    font-size: 14px;
    color: #909399;
    transition: transform 0.2s ease;
    flex-shrink: 0;

    &.is-rotated {
      transform: rotate(180deg);
    }
  }

  &__body {
    padding: 0 4px 18px;
  }

  &__answer {
    font-size: 13px;
    color: #606266;
    margin: 0;
    line-height: 1.7;
  }
}

.faq-slide-enter-active,
.faq-slide-leave-active {
  transition: all 0.2s ease;
  overflow: hidden;
}
.faq-slide-enter,
.faq-slide-leave-to {
  opacity: 0;
  max-height: 0;
  padding-top: 0;
  padding-bottom: 0;
}
.faq-slide-enter-to {
  opacity: 1;
  max-height: 200px;
}
</style>
